__turbopack_context__.v({
  "SoftwarePage__Breadcrumbs": "KBtPyq_SoftwarePage__Breadcrumbs",
  "SoftwarePage__Container": "KBtPyq_SoftwarePage__Container",
  "SoftwarePage__Divider": "KBtPyq_SoftwarePage__Divider",
  "SoftwarePage__Wrapper": "KBtPyq_SoftwarePage__Wrapper",
});
